import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getStopSyncWarningDialog } from '../Selectors'
import ConfirmModal from '../../components/ConfirmModalV2'
import { APPLICATION_STRINGS } from '../../strings'

import createDataDogLog from '../../utils/datadog'
import callable from '../../utils/callable'

import { setDataIsUploading, setSafIsUploading, setSafStatusRequesting } from '../../VNSyncManager/ActionCreators'
import { setSyncWarningDialog } from '../ActionCreators'

import { getDataIsUploading, getSafIsUploading, getSafStatusRequesting } from '../../VNSyncManager/Selectors'
import { getSafResponse, getSafMode } from '../../selectors/appState'
import { getOfflineCardIds, getUnsyncedOrderCounts } from '../../selectors/order'

/**
 * Modal for when attempting to navigate to a different screen while syncing
 *
 * @returns {React.Element}
 */
export const VNStopSyncWarning = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(getStopSyncWarningDialog)?.get('open') || false
  const callback = useSelector(getStopSyncWarningDialog)?.get('callback')

  const dataIsUploading = useSelector(getDataIsUploading)
  const safStatusRequesting = useSelector(getSafStatusRequesting)
  const safIsUploading = useSelector(getSafIsUploading)
  const safResponse = useSelector(getSafResponse)
  const safMode = useSelector(getSafMode)
  const offlineCardIds = useSelector(getOfflineCardIds)

  const [activeOfflineCardCount, unsyncedLocalOrderCount] = useSelector(getUnsyncedOrderCounts)

  if (!isOpen) {
    return null
  }

  return (
    <ConfirmModal
      headerText={''}
      subtext={APPLICATION_STRINGS.STOP_SYNC_WARNING}
      buttonOneText={APPLICATION_STRINGS.STOP_SYNC_NOW}
      buttonTwoText={APPLICATION_STRINGS.CONTINUE_SYNC}
      onButtonOneClick={() => {
        createDataDogLog('info', '[Sync Orders] The attendant manually requested to terminate the sync.', {
          activeOfflineCardCount,
          unsyncedLocalOrderCount,
          offlineCardCount: offlineCardIds?.length,
          safMode,
          safResponse,
          safIsUploading,
          dataIsUploading,
          safStatusRequesting,
        })

        callable(callback)

        // stop saf and data sync
        dispatch(setSafIsUploading(false))
        dispatch(setSafStatusRequesting(false))
        dispatch(setDataIsUploading(false))

        dispatch(setSyncWarningDialog(false))
      }}
      onButtonTwoClick={() => {
        dispatch(setSyncWarningDialog(false))
      }}
    />
  )
}
